// Emir durumunun ekrandaki karşılığı. Tek kaynak: hem `Emirlerim` tablosu hem
// emir log modalı buradan okuyor, ikisi aynı dili konuşsun.
//
// Harfler kullanıcının belirlediği kodlar (2026-07-28):
//   M = tamamen eşleşti · A = hiç/kısmi eşleşti (hâlâ açık)
//   C = iptal edildi     · E = süresi doldu (kontrat kapandı)
//
// `A` bilerek hem "hiç dolmadı" hem "kısmen doldu" durumunu kapsıyor: ikisinde
// de emir hâlâ tahtada ve dolmaya devam edebilir. Ne kadarının dolduğu `Hacim`
// sütununda (0/20 · 8/20) zaten yazıyor.

import type { OrderStatus } from './types'

export interface DurumBilgisi {
  /** Tablodaki tek harflik kod. */
  code: 'M' | 'A' | 'C' | 'E'
  /** Tooltip ve log modalındaki açıklama. */
  label: string
  /** CSS sınıf eki — renk buradan geliyor. */
  tone: 'filled' | 'active' | 'cancelled' | 'expired'
}

const DURUMLAR: Record<OrderStatus, DurumBilgisi> = {
  FILLED: { code: 'M', label: 'Tamamen eşleşti', tone: 'filled' },
  OPEN: { code: 'A', label: 'Açık — hiç veya kısmi eşleşti', tone: 'active' },
  CANCELLED: { code: 'C', label: 'İptal edildi', tone: 'cancelled' },
  EXPIRED: { code: 'E', label: 'Süresi doldu (kontrat kapandı)', tone: 'expired' },
}

/** Bilinmeyen durum gelirse `?` — uydurmak yerine görünür bırakıyoruz. */
export function durumBilgisi(status: string): DurumBilgisi {
  return (
    DURUMLAR[status as OrderStatus] ?? {
      code: '?' as DurumBilgisi['code'],
      label: status,
      tone: 'cancelled',
    }
  )
}
